import {
  REQUESTING,
  REQUEST_SUCCESS,
  REQUEST_ERROR
} from "../types/request.types";

const initialState = {
  success: {},
  error: {},
  requesting: {}
};

const reducer = function requestReducer(state = initialState, action) {
  const newState = { ...initialState };
  switch (action.type) {
    case REQUESTING:
      const { request } = action;
      newState.requesting = request;
      return newState;
    case REQUEST_SUCCESS:
      const { requestSuccess } = action;
      newState.success = requestSuccess;
      return newState;
    case REQUEST_ERROR:
      const { error } = action;
      newState.error = error;
      return newState;
    default:
      return newState;
  }
};

export default reducer;
